import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionButton',
  props: {
  valid: Object,
  selected: Boolean,
  element: Number,
  question: Number,
  status: { type: String, default: '' },
},
  setup(__props) {

const props = __props;



const label = computed(
  (): string => props.element + '.' + ('0' + props.question).substr(-2)
);
const status = computed((): string => {
  const o = [];

  if (props.valid.complete) {
    o.push('complete');
  } else if (props.valid.valid === false) {
    o.push('invalid');
  }
  if (props.selected) o.push('selected');
  return o.join(' ');
});

return { __sfc: true,props, label, status, FontAwesomeIcon }
}

})